import React from 'react';
import { makeStyles } from '@mui/styles';
import LwtTable, { TableColumnProps, TableFilter } from '@lwtears/lwt-common-frontend/lib/Table';

import { SATableNoData } from './SATableNoData';
import { useTheme } from '@mui/material';

interface Props<T> {
  data: T[];
  columns: TableColumnProps<T>[];
  filters: TableFilter[];
  titleNoData: string;
  subTitleNoData: string;
  buttonTitleNoData: string;
  handleNoDataClick: () => void;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export const SATableLayout = <T extends object>({
  data,
  columns,
  filters,
  titleNoData,
  subTitleNoData,
  buttonTitleNoData,
  handleNoDataClick
}: Props<T>): React.ReactElement => {
  const theme = useTheme();
  const classes = useStyles(theme)();
  if (data.length === 0) {
    return (
      <SATableNoData
        handleNoDataClick={handleNoDataClick}
        title={titleNoData}
        subtitle={subTitleNoData}
        buttonTitle={buttonTitleNoData}
      />
    );
  }

  return (
    <LwtTable
      columns={columns}
      data={data}
      filters={filters}
      options={{ sortable: true, paginated: true, filtered: true }}
      classes={
        {
          tableContainer: (): string => classes.tableContainer,
          tableBody: (): string => classes.tableBody,
          tableHead: (): string => classes.tableHead,
          sortIconColor: (): string => classes.sortIconColor
        } as any
      }
    />
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    tableBody: {
      backgroundColor: 'white !important'
    },
    tableContainer: {
      backgroundColor: 'transparent !important',
      boxShadow: 'none !important',
      border: 'none !important'
    },
    tableHead: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(14)
    },
    sortIconColor: () => ({ color: `${theme.palette.text.primary} !important`, marginTop: '-2px' })
  }));
